import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import * as ModalStyles from "./Modal.styles";

export type ModalProps = React.ComponentPropsWithoutRef<"div"> & {
  isOpen: boolean;
  onClose: () => void;
  buttonClose?: boolean;
  width?: string;
};

const Modal = (props: ModalProps) => {
  const { isOpen, onClose, buttonClose = true, width, children } = props;

  const modalRootRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!modalRootRef.current) {
      const div = document.createElement("div");
      document.body.appendChild(div);
      modalRootRef.current = div;
    }

    return () => {
      if (modalRootRef.current) {
        document.body.removeChild(modalRootRef.current);
      }
    };
  }, []);

  if (!isOpen || !modalRootRef.current) return null;

  const modalContent = (
    <ModalStyles.Container>
      <ModalStyles.Overlay onClick={onClose} />
      <ModalStyles.Content width={width}>
        {buttonClose && (
          <ModalStyles.CloseButton onClick={onClose}>X</ModalStyles.CloseButton>
        )}
        {children}
      </ModalStyles.Content>
    </ModalStyles.Container>
  );

  return ReactDOM.createPortal(modalContent, modalRootRef.current);
};

export default Modal;
